import { useEffect, useState } from "react";
import "./image-builder.css";

export function ImageBuilder(props) {
  const plateBuilder = props.plateBuilder
  const [heightFrontBadge, setHeightFrontBadge] = useState('0')
  const [heightRearBadge, setHeightRearBadge] = useState('0')
  const [widthFrontBadge, setWidthFrontBadge] = useState('50')
  const [widthRearBadge, setWidthRearBadge] = useState('0')
  const [sizePlateFront, setSizePlateFront] = useState({
    font: "150px",
    fontField: "90px",
  });
  let symbolCountsFieldFront = 4;
  let symbolCountsFieldRear = 4;
  const [materialClass, setMaterialClass] = useState("");
  const [sizePlateRear, setSizePlateRear] = useState({
    font: "150px",
    fontField: "90px",
  });
  const [mousePosition, setMousePosition] = useState({
    top: "50%",
    left: "50%",
    scale: false,
  });
  useEffect(() => {
    const parentWidth = document.querySelector(".plate-width").clientWidth;
    const propWidth = parentWidth / 22;
    const activeSizeFront = plateBuilder["plate-size"].find((item) => {
      return item.size === props.choosedOptions.plateSizeFront;
    });
    const activeSizeRear = plateBuilder["plate-size"].find((item) => {
      return item.size === props.choosedOptions.plateSizeRear;
    });
    const frontPlateWidth = activeSizeFront
      ? +activeSizeFront.width * propWidth
      : parentWidth;
    const frontPlateHeight = activeSizeFront
      ? frontPlateWidth * (+activeSizeFront.height / +activeSizeFront.width)
      : parentWidth / 4.7;
    const rearPlateWidth = activeSizeRear
      ? +activeSizeRear.width * propWidth
      : parentWidth;
    const rearPlateHeight = activeSizeRear
      ? rearPlateWidth * (+activeSizeRear.height / +activeSizeRear.width)
      : parentWidth / 4.7;
    symbolCountsFieldFront = checkCountSymbol(
      frontPlateWidth,
      frontPlateHeight,
      parentWidth
    );
    symbolCountsFieldRear = checkCountSymbol(
      rearPlateWidth,
      rearPlateHeight,
      parentWidth
    );
    if (props.choosedOptions.plateMaterial !== "null") {
      setMaterialClass(
        props.choosedOptions.plateMaterial.toLowerCase().split(" ").join("-")
      );
    }
    if (props.choosedOptions.plateSizeFront !== "null") {
      if (activeSizeFront) {
        setSizePlateFront((prevState) => ({
          ...prevState,
          breakLine: +activeSizeFront.width / +activeSizeFront.height <= 2.2,
          width: +activeSizeFront.width * propWidth + "px",
          height:
            +activeSizeFront.width *
              propWidth *
              (+activeSizeFront.height / +activeSizeFront.width) +
            "px",
          sloganFont: props.choosedOptions.sloganFont,
        }));
      }
    } else {
      setSizePlateFront((prevState) => ({
        ...prevState,
        width: parentWidth + "px",
        height: parentWidth / 4.7 + "px",
        sloganFont: props.choosedOptions.sloganFont,
        breakLine: false,
      }));
    }
    if (props.choosedOptions.plateSizeRear !== "null") {
      if (activeSizeRear) {
        setSizePlateRear((prevState) => ({
          ...prevState,
          breakLine: +activeSizeRear.width / +activeSizeRear.height <= 2.2,
          width: +activeSizeRear.width * propWidth + "px",
          height:
            +activeSizeRear.width *
              propWidth *
              (+activeSizeRear.height / +activeSizeRear.width) +
            "px",
          sloganFont: props.choosedOptions.sloganFont,
        }));
      }
    } else {
      setSizePlateRear((prevState) => ({
        ...prevState,
        width: parentWidth + "px",
        height: parentWidth / 4.7 + "px",
        sloganFont: props.choosedOptions.sloganFont,
        breakLine: false,
      }));
    }
  }, [props.choosedOptions]);

  useEffect(() => {
    const container = document.querySelector(
      ".image-builder #front-plate .plate-preview__name-wr"
    );
    let fontSize = parseFloat(sizePlateFront.font);
    const desiredWidth = document.querySelector(
      ".image-builder #front-plate .plate-preview__text"
    );
    if (!!container && !container.closest('.plate-preview__two-rows') && !!desiredWidth) {
      if (
        desiredWidth.clientHeight - 20 > container.clientHeight &&
        desiredWidth.clientWidth - 15 > container.clientWidth &&  fontSize <= 150
      ) {
        fontSize++;
        setSizePlateFront((prevState) => ({
          ...prevState,
          font: fontSize + "px",
        }));
      } else if (
            (desiredWidth.clientHeight - 19 <= container.clientHeight ||
            desiredWidth.clientWidth <= container.clientWidth) &&  fontSize > 0 &&
            props.choosedOptions.plateMaterial === '3D Domed'
          ) {
            fontSize--;
            setSizePlateFront((prevState) => ({
              ...prevState,
              font: fontSize + "px",
            }));
          
          
        } else if (
            (desiredWidth.clientHeight - 10 <= container.clientHeight ||
            desiredWidth.clientWidth <= container.clientWidth) &&  fontSize > 0
          ) {
            fontSize--;
            setSizePlateFront((prevState) => ({
              ...prevState,
              font: fontSize + "px",
            }));
          }
      }  
    
  }, [sizePlateFront.font, props.choosedOptions]);
  useEffect(() => {
    const container = document.querySelector(
      ".image-builder #front-plate .plate-preview__two-rows"
    );
    let fontSize = parseFloat(sizePlateFront.fontField);
    const desiredWidth = document.querySelector(
      ".image-builder #front-plate .plate-preview__text"
    );
    if (document.querySelector(".image-builder #front-plate .plate-preview__two-rows") && document.querySelector(
      ".image-builder #front-plate .plate-preview__two-rows"
    ).lastChild ) {
      container.lastChild && setHeightFrontBadge(container.lastChild.clientHeight * 90 / 100)
      container.querySelector('.plate-preview__badge') && setWidthFrontBadge(container.querySelector('.plate-preview__badge').clientWidth === 0 ? container.lastChild.clientHeight * 90 / 100 / 2 : container.querySelector('.plate-preview__badge').scrollWidth)
      if (
        desiredWidth.clientHeight - 20 > container.clientHeight &&
        desiredWidth.clientWidth - 15 > container.clientWidth &&  fontSize <= 150
      ) {
        fontSize++;
        setSizePlateFront((prevState) => ({
          ...prevState,
          fontField: fontSize + "px",
        }));
      } else if (
        desiredWidth.clientHeight - 10 <= container.clientHeight ||
        desiredWidth.clientWidth <= container.clientWidth &&  fontSize > 0
      ) {
        fontSize--;
        setSizePlateFront((prevState) => ({
          ...prevState,
          fontField: fontSize + "px",
        }));
      }
    }
  }, [sizePlateFront.fontField, props.choosedOptions]);
  useEffect(() => {
    const container = document.querySelector(
      ".image-builder #rear-plate .plate-preview__name-wr"
    );
    let fontSize = parseFloat(sizePlateRear.font);
    const desiredWidth = document.querySelector(
      ".image-builder #rear-plate .plate-preview__text"
    );
    if(!!container && !container.closest('.plate-preview__two-rows') && !!desiredWidth) {

    if (
      desiredWidth.clientHeight - 20 > container.clientHeight &&
      desiredWidth.clientWidth - 15 > container.clientWidth &&  fontSize <= 150
    ) {
      fontSize++;
      setSizePlateRear((prevState) => ({
        ...prevState,
        font: fontSize + "px",
      }));
    } else {
      if(props.choosedOptions.plateMaterial === '3D Domed' &&
        desiredWidth.clientHeight - 19 <= container.clientHeight ||
          desiredWidth.clientWidth <= container.clientWidth &&  fontSize > 0
      ) {
          fontSize--;
          setSizePlateRear((prevState) => ({
            ...prevState,
            font: fontSize + "px",
          }));
        
        
      } else if (
          desiredWidth.clientHeight - 10 <= container.clientHeight ||
          desiredWidth.clientWidth <= container.clientWidth &&  fontSize > 0
        ) {
          fontSize--;
          setSizePlateRear((prevState) => ({
            ...prevState,
            font: fontSize + "px",
          }));
        }
        }
      
    }
  }, [sizePlateRear.font, props.choosedOptions]);
  useEffect(() => {
    const container = document.querySelector(
      ".image-builder #rear-plate .plate-preview__two-rows"
    );
    let fontSize = parseFloat(sizePlateRear.fontField);
    const desiredWidth = document.querySelector(
      ".image-builder #rear-plate .plate-preview__text"
    );
    if(document.querySelector(
        ".image-builder #rear-plate .plate-preview__two-rows"
      ) && document.querySelector(
        ".image-builder #rear-plate .plate-preview__two-rows"
      ).lastChild) {
        container.lastChild &&  setHeightRearBadge(container.lastChild.clientHeight * 90 / 100)
        container.querySelector('.plate-preview__badge') && setWidthRearBadge(container.querySelector('.plate-preview__badge').clientWidth === 0 ? container.lastChild.clientHeight * 90 / 100 / 2 : container.querySelector('.plate-preview__badge').clientWidth)
        
        if (
            desiredWidth.clientHeight - 20 > container.clientHeight &&
            desiredWidth.clientWidth - 15 > container.clientWidth &&  fontSize <= 150 
          ) {
            fontSize++;
            setSizePlateRear((prevState) => ({
              ...prevState,
              fontField: fontSize + "px",
            }));
          } else if (
            desiredWidth.clientHeight <= container.clientHeight ||
            desiredWidth.clientWidth <= container.clientWidth &&  fontSize > 0
          ) {
            fontSize--;
            setSizePlateRear((prevState) => ({
              ...prevState,
              fontField: fontSize + "px",
            }));
          }
    }
  }, [sizePlateRear.fontField, props.choosedOptions]);
 

  useEffect(() => {
    if (props.choosedOptions.fontStyle !== "null") {
      const activeFont = plateBuilder["font-family"].find((item) => {
        return item.font === props.choosedOptions.fontStyle;
      });
    }
  }, []);
  useEffect(() => {
    let symbolCountsField =
      symbolCountsFieldFront > symbolCountsFieldRear
        ? parseInt(symbolCountsFieldRear) - 1
        : parseInt(symbolCountsFieldFront) - 1;
    symbolCountsField > 6
      ? (symbolCountsField = 6)
      : (symbolCountsField = symbolCountsField);
      let activeSizeFront = plateBuilder["plate-size"].find((item) => {
        return item.size === props.choosedOptions.plateSizeFront;
      });
      let activeSizeRear = plateBuilder["plate-size"].find((item) => {
        return item.size === props.choosedOptions.plateSizeRear;
      });
      if(!activeSizeFront) {
        activeSizeFront = activeSizeRear 
      }
      if(!activeSizeRear) {
        activeSizeRear = activeSizeFront
      }
      if(!activeSizeRear && !activeSizeFront) {
        if(props.choosedOptions.typeOfTransport === 'car') {
          activeSizeRear = plateBuilder["plate-size"].find((item) => {
            return item.size === 'Standard Car Oblong (20.5x4.4in)';
          })
          activeSizeFront = plateBuilder["plate-size"].find((item) => {
            return item.size === 'Standard Car Oblong (20.5x4.4in)';
          })
  
        } else {
          activeSizeRear = plateBuilder["plate-size"].find((item) => {
            return item.size === 'Standard Motorcycle (9x7in)';
          })
          activeSizeFront = plateBuilder["plate-size"].find((item) => {
            return item.size === 'Standard Motorcycle (9x7in)';
          })
  
        }
      }
  
    if (
      props.choosedOptions.plateMaterial === "3D Domed" ||
      props.choosedOptions.plateMaterial === "4D Raised" ||
      props.choosedOptions.plateMaterial === "5D Raised" ||
      props.choosedOptions.fontStyle === 'laser3d webfont' ||
      props.choosedOptions.fontStyle === 'Dome4D' ||
      props.choosedOptions.fontStyle === 'Dome5D'
    ) {
      if (!activeSizeFront.break || !activeSizeRear.break) {
        let limitCount = 8
        if(
          (props.choosedOptions.badgeLeft !== 'null' || props.choosedOptions.hasCustomBadgeLeft === 'true') &&
          (props.choosedOptions.badgeRight !== 'null' || props.choosedOptions.hasCustomBadgeRight === 'true')
        ) {
          limitCount = 6
          
        if(props.choosedOptions.registrationName.includes(" ")) {
          if(props.choosedOptions.registrationName.match(new RegExp(" ", "g")).length === 1) {
            limitCount = 7
          } else if(props.choosedOptions.registrationName.match(new RegExp(" ", "g")).length === 2) {
            limitCount = 8
          } else {
            limitCount = 6
          }
          
        }  
        }
        symbolCountsField =
          symbolCountsFieldFront > symbolCountsFieldRear
            ? parseInt(symbolCountsFieldRear) - 1
            : parseInt(symbolCountsFieldFront) - 1;
        if (props.choosedOptions.registrationName.length > limitCount) {
          let regName = props.choosedOptions.registrationName;
          if (activeSizeFront.break || activeSizeRear.break) {
            regName = props.choosedOptions.registrationName.replace(/\s/g, "");
            props.updateChoosedOptions({
              registrationName:
                regName.slice(0, 4) + " " + regName.slice(4, limitCount - 1).trim(),
              registrationNameFirst: regName.slice(0, 4),
              registrationNameSecond: regName.slice(4, limitCount - 1).trim(),
            });
          } else {
            props.updateChoosedOptions({
              registrationName: regName.slice(0, limitCount),
              registrationNameFirst: regName.slice(0, 4),
              registrationNameSecond: regName.slice(4, limitCount).trim(),
            });
          }
          if(
            (props.choosedOptions.badgeLeft !== 'null' || props.choosedOptions.hasCustomBadgeLeft === 'true') &&
            (props.choosedOptions.badgeRight !== 'null' || props.choosedOptions.hasCustomBadgeRight === 'true')
          ) {
            props.checkValid({
              isValid: false,
              typePlate: "3d-effect-limit",
            });

          } else {
            props.checkValid({
              isValid: false,
              typePlate: "3d-effect",
            });

          }
        }
      } else {
        if (
          (props.choosedOptions.registrationNameFirst.length >
            symbolCountsField &&
            props.choosedOptions.registrationNameSecond.length !== 0) ||
          (props.choosedOptions.registrationNameSecond.length >
            symbolCountsField &&
            props.choosedOptions.registrationNameFirst.length !== 0) ||
          (props.choosedOptions.registrationNameFirst.length > 4 &&
            props.choosedOptions.registrationNameFirst.length >
              symbolCountsField &&
            props.choosedOptions.registrationNameSecond.length === 0) ||
          (props.choosedOptions.registrationNameFirst.length === 0 &&
            props.choosedOptions.registrationNameSecond.length > 4 &&
            props.choosedOptions.registrationNameSecond.length >
              symbolCountsField)
        ) {
          let regName = props.choosedOptions.registrationName.replace(
            /\s/g,
            ""
          );
          if (props.choosedOptions.registrationNameFirst.length === 0) {
            props.updateChoosedOptions({
              registrationName: regName.slice(0, symbolCountsField),
              registrationNameSecond: regName.slice(0, symbolCountsField),
            });
          } else if (props.choosedOptions.registrationNameSecond.length === 0) {
            props.updateChoosedOptions({
              registrationName: regName.slice(0, symbolCountsField),
              registrationNameFirst: regName.slice(0, symbolCountsField),
            });
          } else if (
            props.choosedOptions.registrationNameFirst.length >
              symbolCountsField &&
            props.choosedOptions.registrationNameSecond.length >
              symbolCountsField
          ) {
            props.updateChoosedOptions({
              registrationName:
                regName.slice(0, parseInt(symbolCountsFieldFront)) +
                regName.slice(
                  props.choosedOptions.registrationNameFirst.length,
                  props.choosedOptions.registrationNameFirst.length +
                    symbolCountsField
                ),
              registrationNameFirst: regName.slice(0, symbolCountsField),
              registrationNameSecond: regName.slice(
                props.choosedOptions.registrationNameFirst.length,
                props.choosedOptions.registrationNameFirst.length +
                  parseInt(symbolCountsFieldFront)
              ),
            });
          } else if (
            props.choosedOptions.registrationNameSecond.length >
            symbolCountsField
          ) {
            props.updateChoosedOptions({
              registrationName:
                props.choosedOptions.registrationNameFirst +
                regName.slice(
                  props.choosedOptions.registrationNameFirst.length,
                  props.choosedOptions.registrationNameFirst.length + 8
                ),
              registrationNameSecond: regName.slice(
                props.choosedOptions.registrationNameFirst.length,
                props.choosedOptions.registrationNameFirst.length +
                  symbolCountsField
              ),
            });
          } else if (
            props.choosedOptions.registrationNameFirst.length >
            symbolCountsField
          ) {
            props.updateChoosedOptions({
              registrationName:
                regName.slice(0, symbolCountsField) +
                props.choosedOptions.registrationNameSecond,
              registrationNameFirst:
                props.choosedOptions.registrationName.slice(
                  0,
                  symbolCountsField
                ),
            });
          }
          if(
            (props.choosedOptions.badgeLeft !== 'null' || props.choosedOptions.hasCustomBadgeLeft === 'true') &&
            (props.choosedOptions.badgeRight !== 'null' || props.choosedOptions.hasCustomBadgeRight === 'true')
          ) {
            props.checkValid({
              isValid: false,
              typePlate: "3d-effect-limit",
              cut: symbolCountsFieldFront,
            });

          } else {
            props.checkValid({
              isValid: false,
              typePlate: "3d-effect",
              cut: symbolCountsFieldFront,
            });

          }
        }
      }
    }
  }, [
    props.choosedOptions.plateSizeFront,
    props.choosedOptions.plateSizeRear,
    props.choosedOptions.registrationName,
    props.choosedOptions.plateMaterial,
    props.choosedOptions.fontStyle,
    props.choosedOptions.hasCustomBadgeLeft,
    props.choosedOptions.hasCustomBadgeRight,
    props.choosedOptions.badgeLeft,
    props.choosedOptions.badgeRight,
  ]);
  useEffect(() => {
    if (
      (props.choosedOptions.plateMaterial === "Pressed Metal" ||
        props.choosedOptions.plateMaterial === "Pressed Metal Black") &&
      props.choosedOptions.registrationName.split(" ").length - 1 === 3
    ) {
      props.updateChoosedOptions({
        registrationName: props.choosedOptions.registrationName.slice(0, -1),
      });
      props.checkValid({
        isValid: false,
        typePlate: "pressed-metal",
      });
    }
    if (
      (props.choosedOptions.plateMaterial === "Pressed Metal" ||
        props.choosedOptions.plateMaterial === "Pressed Metal Black") &&
      props.choosedOptions.registrationName.length > 7
    ) {
      const spaces =
        props.choosedOptions.registrationName.split(" ").length - 1;
      if (spaces === 1 && props.choosedOptions.registrationName.length > 8) {
        props.updateChoosedOptions({
          registrationName: props.choosedOptions.registrationName.slice(0, 8),
        });
        props.checkValid({
          isValid: false,
          typePlate: "pressed-metal",
        });
      } else if (
        spaces >= 2 &&
        props.choosedOptions.registrationName.length > 9
      ) {
        props.updateChoosedOptions({
          registrationName: props.choosedOptions.registrationName.slice(0, 9),
        });
        props.checkValid({
          isValid: false,
          typePlate: "pressed-metal",
        });
      } else if (spaces === 0) {
        props.updateChoosedOptions({
          registrationName: props.choosedOptions.registrationName.slice(0, 7),
        });
        props.checkValid({
          isValid: false,
          typePlate: "pressed-metal",
        });
      }
    }
  }, [
    props.choosedOptions.registrationName,
    props.choosedOptions.plateMaterial,
  ]);
  const ZoomPlate = (e) => {
    const rect = e.target.getBoundingClientRect();
    setMousePosition({
      left: (100 * (e.clientX - rect.left)) / e.target.offsetWidth + "%",
      top: (100 * (e.clientY - rect.top)) / e.target.offsetHeight + "%",
      scale: true,
    });
  };
  const ZoomByTouch = (e) => {
    document.querySelector("html").style.overflowY = "hidden";
    document.querySelector(".image-builder__zoom").classList.add("zoom");
    setMousePosition({
      left: (100 * e.touches[0].clientX) / e.target.offsetWidth + "%",
      top: (100 * (e.touches[0].clientY - e.target.getBoundingClientRect().top)) / e.target.offsetHeight + "%",
      scale: true,
    });
  };
  const touchEnd = () => {
    document.querySelector(".image-builder__zoom").classList.remove("zoom");
    document.querySelector("html").style.overflowY = "unset";
  };
  const checkCountSymbol = (width, height, parentWidth) => {
    if (width / height >= 1.8) {
      if (
        (props.choosedOptions.registrationNameFirst.length > 0 &&
          props.choosedOptions.registrationNameSecond.length > 0) ||
        props.defaultName
      ) {
        if (
          (props.choosedOptions.registrationNameFirst.length <= 8 &&
            props.choosedOptions.registrationNameSecond.length <= 8) ||
          props.defaultName
        ) {
          return 8;
        }
      } else {
        if (
          props.choosedOptions.registrationNameFirst.length <= 4 &&
          props.choosedOptions.registrationNameSecond.length <= 4
        ) {
          return 4;
        }
      }
    } else {
      if (
        (props.choosedOptions.registrationNameFirst.length > 0 &&
          props.choosedOptions.registrationNameSecond.length > 0) ||
        props.defaultName
      ) {
        if (
          (props.choosedOptions.registrationNameFirst.length <= 5 &&
            props.choosedOptions.registrationNameSecond.length <= 5) ||
          props.defaultName
        ) {
          if (
            parentWidth / width > 3.1 &&
            width / height < 1.41 &&
            width / height > 1.29
          ) {
            return 5.9;
          } else if (parentWidth / width > 3.1 && width / height <= 1.29) {
            return 5;
          } else if (parentWidth / width > 3.1 && width / height >= 1.6) {
            return 6.9;
          }
          if (
            parentWidth / width > 3 &&
            width / height < 1.7 &&
            width / height >= 1.49
          ) {
            return 5.5;
          } else if (parentWidth / width > 3 && width / height >= 1.7) {
            return 6.9;
          }
          if (parentWidth / width < 2.5) {
            return 5.5;
          }
          return 4.8;
        }
      } else {
        if (
          props.choosedOptions.registrationNameFirst.length <= 3 &&
          props.choosedOptions.registrationNameSecond.length <= 3
        ) {
          return 3;
        }
      }
    }
    return props.choosedOptions.registrationNameFirst.length >
      props.choosedOptions.registrationNameSecond.length
      ? props.choosedOptions.registrationNameFirst.length + 0.5
      : props.choosedOptions.registrationNameSecond.length + 0.5;
  };
  return (
    <div
      className={`${
        props.choosedOptions.plateMaterial === "Silver" ? "silver-bg" : ""
      } image-builder`}
      onTouchEnd={() => touchEnd()}
      onTouchMove={(e) => ZoomByTouch(e)}
      onMouseMove={(e) => ZoomPlate(e)}
    >
      <div
        className="image-builder__zoom"
        style={{
          transformOrigin: `${mousePosition.left} ${mousePosition.top}`,
        }}
      >
        <h3 className="image-builder__title">Your Plate Preview</h3>
        <div className=" image-builder__grid plate-width flex flex-col justify-center ">
          {props.choosedOptions.frontPlate === "true" && (
            <div
              id="front-plate"
              className={`${materialClass} ${
                parseFloat(sizePlateFront.height) < 80 ||
                parseFloat(sizePlateFront.width) < 160
                  ? " small-border"
                  : ""
              } 
                                ${
                                  props.choosedOptions.badgeInsideBorder ===
                                  "true"
                                    ? "border-inside"
                                    : ""
                                }
                    ${
                      props.choosedOptions.fontStyle === "laser3d webfont"
                        ? "font-3d"
                        : ""
                    } 
                        ${
                          props.choosedOptions.fontStyle === "CharlesWright Motorcycle"
                            ? "moto"
                            : ""
                        } 
                    ${
                      props.choosedOptions.fontStyle === "null" ||
                      props.choosedOptions.fontStyle === "CharlesWright Bold" ||
                      props.choosedOptions.fontStyle ===
                        "CharlesWright Motorcycle" ||
                      props.choosedOptions.fontStyle === "CharlesWright1935" ||
                      props.choosedOptions.fontStyle === "Marhey" ||
                      props.choosedOptions.fontStyle === "Bebas Neue" ||
                      props.choosedOptions.fontStyle === "Great Vibes"
                        ? "standard"
                        : ""
                    } 
                    ${
                      props.choosedOptions.fontStyle === "Charles Wright Carbon"
                        ? "font-image"
                        : ""
                    } 
                    ${
                      props.choosedOptions.fontStyle === "Plate3d"
                        ? "font-gray"
                        : ""
                    } 
                    ${
                      props.choosedOptions.fontStyle === "Dome4D"
                        ? "font-4d"
                        : ""
                    } 
                    ${
                      props.choosedOptions.fontStyle === "Dome5D"
                        ? "font-5d"
                        : ""
                    } 
                    ${
                      props.choosedOptions.fontStyle === "laser inline webfont"
                        ? "font-4d-cut"
                        : ""
                    } 
                    ${
                      (props.choosedOptions.badgeLeft !== "null" ||
                        props.choosedOptions.hasCustomBadgeLeft === "true") &&
                      " has-badge-left"
                    } 
                    ${
                      (props.choosedOptions.badgeRight !== "null" ||
                        props.choosedOptions.hasCustomBadgeRight === "true") &&
                      " has-badge-right"
                    } 
                    ${
                      (props.choosedOptions.borderWidth !== "null" &&
                      props.choosedOptions.borderWidth !== "None") &&
                      " has-border"
                    } 
                    ${(sizePlateFront.breakLine && props.choosedOptions.badgeInsideBorder === 'false' && props.choosedOptions.categoryPlate.includes("standard") && props.choosedOptions.fullHeightBadge === "false" && 
                        props.choosedOptions.borderWidth !== "null" &&
                        props.choosedOptions.borderWidth !== "None") && ' cut-badge '}
                    plate-preview flex items-center justify-center`}
              style={{
                width: sizePlateFront.width,
                height: sizePlateFront.height,
                "--color":
                  props.choosedOptions.categoryPlate.includes("show")
                    ? props.choosedOptions.fontColor
                    : "black",
                "--font-family":
                  props.choosedOptions.fontStyle !== "null"
                    ? props.choosedOptions.fontStyle
                    : "CharlesWright Bold",
                "--border-width":
                  props.choosedOptions.borderWidth !== "null" &&
                  props.choosedOptions.borderWidth !== "None"
                    ? `${props.choosedOptions.borderWidth}px`
                    : "0px",
                "--border-color":
                  props.choosedOptions.borderColor !== "null"
                    ? `${props.choosedOptions.borderColor}`
                    : "black",
              }}
            >
              {((props.choosedOptions.badgeLeft !== "null" && !sizePlateFront.breakLine) ||
                (props.choosedOptions.badgeLeft !== "null" && props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.hasCustomBadgeLeft === "true" &&  props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.hasCustomBadgeLeft === "true" && !sizePlateFront.breakLine) ||
                (props.choosedOptions.registrationNameSecond.length === 0 && !props.defaultName && (props.choosedOptions.badgeLeft !== "null" || props.choosedOptions.hasCustomBadgeLeft === "true")) || 
                (sizePlateFront.breakLine && props.choosedOptions.badgeInsideBorder === 'false' && props.choosedOptions.categoryPlate.includes("standard") && props.choosedOptions.fullHeightBadge === "false" && props.choosedOptions.borderWidth !== "null" && props.choosedOptions.borderWidth !== "None" && (props.choosedOptions.badgeLeft !== "null" || props.choosedOptions.hasCustomBadgeLeft === "true"))) && (
                <div
                  className="plate-preview__badge"
                  style={{
                    "background-color":
                      props.choosedOptions.badgeColorLeft !== "null" &&
                      props.choosedOptions.badgeColorLeft,
                    color:
                      props.choosedOptions.customBadgeTextColorLeft !==
                        "null" && props.choosedOptions.customBadgeTextColorLeft,
                  }}
                >
                  {props.choosedOptions.hasCustomBadgeLeft === "false" && (
                    <img
                      width="58"
                      height="132"
                      src={props.choosedOptions.badgeLeft}
                      alt="badge"
                    />
                  )}
                  {props.choosedOptions.hasCustomBadgeLeft === "true" &&
                    props.choosedOptions.customBadgeLeft && (
                      <img
                        width="58"
                        height="132"
                        src={props.choosedOptions.customBadgeLeft}
                        alt=" custom badge"
                      />
                    )}
                </div>
              )}
              <div className="plate-preview__text flex items-center justify-center">
                {props.choosedOptions.sloganName.length > 0 && (
                  <div
                    className="plate-preview__slogan"
                    style={{
                      "--font-size": props.choosedOptions.sloganFont,
                      "font-family": props.choosedOptions.sloganStyle + ', sans-serif',
                      color: props.choosedOptions.sloganColor,
                      "--width": sizePlateFront.width,
                      "--height": sizePlateFront.height,
                    }}
                  >
                    {props.choosedOptions.sloganName.replaceAll(/\\'/g, "'")}
                  </div>
                )}
                {sizePlateFront.breakLine && (
                  <div
                    className={
                      " plate-preview__two-rows " +
                      ((props.choosedOptions.badgeLeft !== "null" ||
                        props.choosedOptions.hasCustomBadgeLeft === "true" ||
                        props.choosedOptions.badgeRight !== "null" ||
                        props.choosedOptions.hasCustomBadgeRight === "true") &&
                        props.choosedOptions.fullHeightBadge === "false" &&
                        "badge-inside ") +
                      ((props.choosedOptions.badgeRight !== "null" ||
                        props.choosedOptions.hasCustomBadgeRight === "true") &&
                        props.choosedOptions.fullHeightBadge === "false" &&
                        "badge-inside-right ") +
                      ((props.choosedOptions.badgeLeft !== "null" ||
                        props.choosedOptions.hasCustomBadgeLeft === "true") &&
                        (props.choosedOptions.badgeRight !== "null" ||
                          props.choosedOptions.hasCustomBadgeRight ===
                            "true") &&
                        props.choosedOptions.fullHeightBadge === "false" &&
                        " two-badge")
                    }
                  >
                    {(props.choosedOptions.registrationNameFirst.length > 0 ||
                      props.defaultName) && (
                      <div
                        className={
                          "plate-preview__name-wr" +
                          (props.choosedOptions.registrationNameSecond.length >
                          4
                            ? " small-font"
                            : "")
                        }
                      >
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateFront.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "AB12"
                              : props.choosedOptions.registrationNameFirst}
                          </span>
                        </div>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateFront.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "AB12"
                              : props.choosedOptions.registrationNameFirst}
                          </span>
                        </div>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateFront.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "AB12"
                              : props.choosedOptions.registrationNameFirst}
                          </span>
                        </div>
                      </div>
                    )}
                    {(props.choosedOptions.registrationNameSecond.length > 0 ||
                      props.defaultName) && (
                        <>
                        {(props.choosedOptions.badgeLeft !== "null" ||
                          props.choosedOptions.hasCustomBadgeLeft === "true") &&
                          props.choosedOptions.fullHeightBadge === "false" &&
                          (props.choosedOptions.registrationNameFirst.length >
                            0 ||
                            props.defaultName) && (
                            <div
                              className="plate-preview__badge"
                              style={{
                                "--heightBadge": heightFrontBadge + 'px',
                                "background-color":
                                  props.choosedOptions.badgeColorLeft !==
                                    "null" &&
                                  props.choosedOptions.badgeColorLeft,
                                color:
                                  props.choosedOptions
                                    .customBadgeTextColorLeft !== "null" &&
                                  props.choosedOptions.customBadgeTextColorLeft,
                              }}
                            >
                              {props.choosedOptions.hasCustomBadgeLeft ===
                                "false" && (
                                <img
                                  width="58"
                                  height="132"
                                  src={props.choosedOptions.badgeLeft}
                                  alt="badge"
                                />
                              )}
                              {props.choosedOptions.hasCustomBadgeLeft ===
                                "true" &&
                                props.choosedOptions.customBadgeLeft && (
                                  <img
                                    width="58"
                                    height="132"
                                    src={props.choosedOptions.customBadgeLeft}
                                    alt=" custom badge"
                                  />
                                )}
                            </div>
                          )}
                        {(props.choosedOptions.badgeRight !== "null" ||
                          props.choosedOptions.hasCustomBadgeRight ===
                            "true") &&
                          props.choosedOptions.fullHeightBadge === "false" &&
                          (props.choosedOptions.registrationNameFirst.length >
                            0 ||
                            props.defaultName) && (
                            <div
                              className="plate-preview__badge plate-preview__badge--right"
                              style={{
                                "--heightBadge": heightFrontBadge + 'px',
                                "background-color":
                                  props.choosedOptions.badgeColorRight !==
                                    "null" &&
                                  props.choosedOptions.badgeColorRight,
                                color:
                                  props.choosedOptions
                                    .customBadgeTextColorRight !== "null" &&
                                  props.choosedOptions
                                    .customBadgeTextColorRight,
                              }}
                            >
                              {props.choosedOptions.hasCustomBadgeRight ===
                                "false" && (
                                <img
                                  width="58"
                                  height="132"
                                  src={props.choosedOptions.badgeRight}
                                  alt="badge"
                                />
                              )}
                              {props.choosedOptions.hasCustomBadgeRight ===
                                "true" &&
                                props.choosedOptions.customBadgeRight && (
                                  <img
                                    width="58"
                                    height="132"
                                    src={props.choosedOptions.customBadgeRight}
                                    alt=" custom badge"
                                  />
                                )}
                            </div>
                          )}

                          <div
                            className={
                              "plate-preview__name-wr" +
                              (props.choosedOptions.registrationNameSecond.length >
                              4
                                ? " small-font"
                                : "")
                            }
                            style={{
                              "padding-right": (props.choosedOptions.badgeRight !== "null" ||
                              props.choosedOptions.hasCustomBadgeRight ===
                                "true") &&
                              props.choosedOptions.fullHeightBadge === "false" ? widthFrontBadge + 8 + 'px': '0px',
                              "padding-left":  (props.choosedOptions.badgeLeft !== "null" ||
                              props.choosedOptions.hasCustomBadgeLeft === "true") &&
                              props.choosedOptions.fullHeightBadge === "false" ? widthFrontBadge + 8 + 'px' : '0px',
                            }}
                          >
                          <div style={{position: 'relative'}}>
                            <div
                              className="plate-preview__name"
                              style={{
                                "--font-size": sizePlateFront.fontField,
                                "line-height": "1",
                              }}
                            >
                              <span>
                                {props.defaultName
                                  ? "CDE"
                                  : props.choosedOptions.registrationNameSecond}
                              </span>
                            </div>
                            <div
                              className="plate-preview__name"
                              style={{
                                "--font-size": sizePlateFront.fontField,
                                "line-height": "1",
                              }}
                            >
                              <span>
                                {props.defaultName
                                  ? "CDE"
                                  : props.choosedOptions.registrationNameSecond}
                              </span>
                            </div>
                            <div
                              className="plate-preview__name"
                              style={{
                                "--font-size": sizePlateFront.fontField,
                                "line-height": "1",
                              }}
                            >
                              <span>
                                {props.defaultName
                                  ? "CDE"
                                  : props.choosedOptions.registrationNameSecond}
                              </span>
                            </div>
                          </div>
                          </div>
                        </>
                    )}
                  </div>
                )}
                {!sizePlateFront.breakLine && (
                  <div className="plate-preview__name-wr">
                    <div
                      className="plate-preview__name"
                      style={{ "--font-size": sizePlateFront.font }}
                    >
                      <span>
                        {props.defaultName
                          ? "AB12 CDE"
                          : props.choosedOptions.registrationName}
                      </span>
                    </div>
                    <div
                      className="plate-preview__name"
                      style={{ "--font-size": sizePlateFront.font }}
                    >
                      <span>
                        {props.defaultName
                          ? "AB12 CDE"
                          : props.choosedOptions.registrationName}
                      </span>
                    </div>
                    <div
                      className="plate-preview__name"
                      style={{ "--font-size": sizePlateFront.font }}
                    >
                      <span>
                        {props.defaultName
                          ? "AB12 CDE"
                          : props.choosedOptions.registrationName}
                      </span>
                    </div>
                    </div>
                )}

                {props.choosedOptions.showBSAU === "true" && (
                  <div
                    className={
                      props.choosedOptions.borderWidth === "null" ||
                      props.choosedOptions.borderWidth === "None"
                        ? "plate-preview__bsau bottom "
                        : "plate-preview__bsau"
                    }
                  >
                    SPM BSAU 145e
                  </div>
                )}
              </div>
              {((props.choosedOptions.badgeRight !== "null" &&
                !sizePlateFront.breakLine) ||
                (props.choosedOptions.badgeRight !== "null" &&
                  props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.hasCustomBadgeRight === "true" &&
                  !sizePlateFront.breakLine) ||
                (props.choosedOptions.hasCustomBadgeRight === "true" &&
                  props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.registrationNameSecond.length === 0 &&
                  !props.defaultName &&
                  (props.choosedOptions.badgeRight !== "null" ||
                    props.choosedOptions.hasCustomBadgeRight === "true"))) && (
                <div
                  className="plate-preview__badge plate-preview__badge--right"
                  style={{
                    "background-color":
                      props.choosedOptions.badgeColorRight !== "null" &&
                      props.choosedOptions.badgeColorRight,
                    color:
                      props.choosedOptions.customBadgeTextColorRight !==
                        "null" &&
                      props.choosedOptions.customBadgeTextColorRight,
                  }}
                >
                  {props.choosedOptions.hasCustomBadgeRight === "false" && (
                    <img
                      width="58"
                      height="132"
                      src={props.choosedOptions.badgeRight}
                      alt="badge"
                    />
                  )}
                  {props.choosedOptions.hasCustomBadgeRight === "true" &&
                    props.choosedOptions.customBadgeRight && (
                      <img
                        width="58"
                        height="132"
                        src={props.choosedOptions.customBadgeRight}
                        alt=" custom badge"
                      />
                    )}
                </div>
              )}
            </div>
          )}
          {props.choosedOptions.rearPlate === "true" && (
            <div
              id="rear-plate"
              className={`${materialClass} ${
                parseFloat(sizePlateRear.height) < 80 ||
                parseFloat(sizePlateRear.width) < 160
                  ? "small-border"
                  : ""
              }  
                                ${
                                  props.choosedOptions.badgeInsideBorder ===
                                  "true"
                                    ? "border-inside"
                                    : ""
                                }
                        ${
                          props.choosedOptions.fontStyle === "laser3d webfont"
                            ? "font-3d"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle === "CharlesWright Motorcycle"
                            ? "moto"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle === "null" ||
                          props.choosedOptions.fontStyle ===
                            "CharlesWright Bold" ||
                          (props.choosedOptions.fontStyle ===
                            "CharlesWright Motorcycle") |
                            (props.choosedOptions.fontStyle ===
                              "CharlesWright1935") ||
                          props.choosedOptions.fontStyle === "Marhey" ||
                          props.choosedOptions.fontStyle === "Bebas Neue"||
                          props.choosedOptions.fontStyle === "Great Vibes"
                            ? "standard"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle === "Plate3d"
                            ? "font-gray"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle ===
                          "Charles Wright Carbon"
                            ? "font-image"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle === "Dome4D"
                            ? "font-4d"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle === "Dome5D"
                            ? "font-5d"
                            : ""
                        } 
                        ${
                          props.choosedOptions.fontStyle ===
                          "laser inline webfont"
                            ? "font-4d-cut"
                            : ""
                        } 
                        ${
                          (props.choosedOptions.badgeLeft !== "null" ||
                            props.choosedOptions.hasCustomBadgeLeft ===
                              "true") &&
                          "has-badge-left"
                        } 
                        ${
                          (props.choosedOptions.badgeRight !== "null" ||
                            props.choosedOptions.hasCustomBadgeRight ===
                              "true") &&
                          "has-badge-right"
                        }  
                        ${
                          (props.choosedOptions.borderWidth !== "null" &&
                          props.choosedOptions.borderWidth !== "None") &&
                          " has-border"
                        } 
                        ${(sizePlateRear.breakLine && props.choosedOptions.badgeInsideBorder === 'false' && props.choosedOptions.categoryPlate.includes("standard") && props.choosedOptions.fullHeightBadge === "false" && 
                        props.choosedOptions.borderWidth !== "null" &&
                        props.choosedOptions.borderWidth !== "None") && ' cut-badge '}
                        plate-preview plate-preview--rear flex items-center justify-center`}
              style={{
                width: sizePlateRear.width,
                height: sizePlateRear.height,
                "--color":
                  props.choosedOptions.categoryPlate.includes("show")
                    ? props.choosedOptions.fontColor
                    : "black",
                "--font-family":
                  props.choosedOptions.fontStyle !== "null"
                    ? props.choosedOptions.fontStyle
                    : "CharlesWright Bold",
                "--border-width":
                  props.choosedOptions.borderWidth !== "null" &&
                  props.choosedOptions.borderWidth !== "None"
                    ? `${props.choosedOptions.borderWidth}px`
                    : "0px",
                "--border-color":
                  props.choosedOptions.borderColor !== "null"
                    ? `${props.choosedOptions.borderColor}`
                    : "black",
              }}
            >
              {((props.choosedOptions.badgeLeft !== "null" && !sizePlateRear.breakLine) ||
                (props.choosedOptions.badgeLeft !== "null" && props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.hasCustomBadgeLeft === "true" && !sizePlateRear.breakLine) ||
                (props.choosedOptions.hasCustomBadgeLeft === "true" && props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.registrationNameSecond.length === 0 && !props.defaultName && (props.choosedOptions.badgeLeft !== "null" || props.choosedOptions.hasCustomBadgeLeft === "true")) || 
                (sizePlateRear.breakLine && props.choosedOptions.badgeInsideBorder === 'false' && props.choosedOptions.categoryPlate.includes("standard") && props.choosedOptions.fullHeightBadge === "false" && 
                    props.choosedOptions.borderWidth !== "null" &&
                    props.choosedOptions.borderWidth !== "None") && props.choosedOptions.badgeLeft !== "null") && (
                <div
                  className="plate-preview__badge"
                  style={{
                    "background-color":
                      props.choosedOptions.badgeColorLeft !== "null" &&
                      props.choosedOptions.badgeColorLeft,
                    color:
                      props.choosedOptions.customBadgeTextColorLeft !==
                        "null" && props.choosedOptions.customBadgeTextColorLeft,
                  }}
                >
                  {props.choosedOptions.hasCustomBadgeLeft === "false" && (
                    <img
                      width="58"
                      height="132"
                      src={props.choosedOptions.badgeLeft}
                      alt="badge"
                    />
                  )}
                  {props.choosedOptions.hasCustomBadgeLeft === "true" &&
                    props.choosedOptions.customBadgeLeft && (
                      <img
                        width="58"
                        height="132"
                        src={props.choosedOptions.customBadgeLeft}
                        alt=" custom badge"
                      />
                    )}
                </div>
              )}
              <div className="plate-preview__text flex items-center justify-center">
                {props.choosedOptions.sloganName.length > 0 && (
                  <div
                    className="plate-preview__slogan"
                    style={{
                      "--font-size": props.choosedOptions.sloganFont,
                      "font-family": props.choosedOptions.sloganStyle + ', sans-serif',
                      color: props.choosedOptions.sloganColor,
                      "--width": sizePlateRear.width,
                      "--height": sizePlateRear.height,
                    }}
                  >
                    {props.choosedOptions.sloganName.replaceAll(/\\'/g, "'")}
                  </div>
                )}

                {sizePlateRear.breakLine && (
                  <div
                    className={
                      ((props.choosedOptions.badgeLeft !== "null" ||
                        props.choosedOptions.hasCustomBadgeLeft === "true" ||
                        props.choosedOptions.badgeRight !== "null" ||
                        props.choosedOptions.hasCustomBadgeRight === "true") &&
                        props.choosedOptions.fullHeightBadge === "false" &&
                        "badge-inside ") +
                      ((props.choosedOptions.badgeRight !== "null" ||
                        props.choosedOptions.hasCustomBadgeRight === "true") &&
                        props.choosedOptions.fullHeightBadge === "false" &&
                        "badge-inside-right ") +
                      ((props.choosedOptions.badgeLeft !== "null" ||
                        props.choosedOptions.hasCustomBadgeLeft === "true") &&
                        (props.choosedOptions.badgeRight !== "null" ||
                          props.choosedOptions.hasCustomBadgeRight ===
                            "true") &&
                        props.choosedOptions.fullHeightBadge === "false" &&
                        " two-badge") +
                      " plate-preview__two-rows"
                    }
                  >
                    {(props.choosedOptions.registrationNameFirst.length > 0 ||
                      props.defaultName) && (
                      <div
                        className={
                          "plate-preview__name-wr" +
                          (props.choosedOptions.registrationNameSecond.length >
                          4
                            ? " small-font"
                            : "")
                        }
                      >
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateRear.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "AB12"
                              : props.choosedOptions.registrationNameFirst}
                          </span>
                        </div>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateRear.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "AB12"
                              : props.choosedOptions.registrationNameFirst}
                          </span>
                        </div>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateRear.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "AB12"
                              : props.choosedOptions.registrationNameFirst}
                          </span>
                        </div>
                      </div>
                    )}
                    {(props.choosedOptions.registrationNameSecond.length > 0 ||
                      props.defaultName) && (
                      <>
                       {(props.choosedOptions.badgeLeft !== "null" ||
                          props.choosedOptions.hasCustomBadgeLeft === "true") &&
                          props.choosedOptions.fullHeightBadge === "false" &&
                          (props.choosedOptions.registrationNameFirst.length >
                            0 ||
                            props.defaultName) && (
                            <div
                              className="plate-preview__badge"
                              style={{
                                "--heightBadge": heightRearBadge + 'px',
                                "background-color":
                                  props.choosedOptions.badgeColorLeft !==
                                    "null" &&
                                  props.choosedOptions.badgeColorLeft,
                                color:
                                  props.choosedOptions
                                    .customBadgeTextColorLeft !== "null" &&
                                  props.choosedOptions.customBadgeTextColorLeft,
                              }}
                            >
                              {props.choosedOptions.hasCustomBadgeLeft ===
                                "false" && (
                                <img
                                  width="58"
                                  height="132"
                                  src={props.choosedOptions.badgeLeft}
                                  alt="badge"
                                />
                              )}
                              {props.choosedOptions.hasCustomBadgeLeft ===
                                "true" &&
                                props.choosedOptions.customBadgeLeft && (
                                  <img
                                    width="58"
                                    height="132"
                                    src={props.choosedOptions.customBadgeLeft}
                                    alt=" custom badge"
                                  />
                                )}
                            </div>
                          )}
                        {(props.choosedOptions.badgeRight !== "null" ||
                          props.choosedOptions.hasCustomBadgeRight ===
                            "true") &&
                          props.choosedOptions.fullHeightBadge === "false" &&
                          (props.choosedOptions.registrationNameFirst.length >
                            0 ||
                            props.defaultName) && (
                            <div
                              className="plate-preview__badge plate-preview__badge--right"
                              style={{
                                "--heightBadge": heightRearBadge + 'px',
                                "background-color":
                                  props.choosedOptions.badgeColorRight !==
                                    "null" &&
                                  props.choosedOptions.badgeColorRight,
                                color:
                                  props.choosedOptions
                                    .customBadgeTextColorRight !== "null" &&
                                  props.choosedOptions
                                    .customBadgeTextColorRight,
                              }}
                            >
                              {props.choosedOptions.hasCustomBadgeRight ===
                                "false" && (
                                <img
                                  width="58"
                                  height="132"
                                  src={props.choosedOptions.badgeRight}
                                  alt="badge"
                                />
                              )}
                              {props.choosedOptions.hasCustomBadgeRight ===
                                "true" &&
                                props.choosedOptions.customBadgeRight && (
                                  <img
                                    width="58"
                                    height="132"
                                    src={props.choosedOptions.customBadgeRight}
                                    alt=" custom badge"
                                  />
                                )}
                            </div>
                          )}
                      <div
                        className={
                          "plate-preview__name-wr" +
                          (props.choosedOptions.registrationNameSecond.length >
                          4
                            ? " small-font"
                            : "")
                        }
                        style={{
                          "padding-right": (props.choosedOptions.badgeRight !== "null" ||
                          props.choosedOptions.hasCustomBadgeRight ===
                            "true") &&
                          props.choosedOptions.fullHeightBadge === "false" ? widthRearBadge + 8 + 'px': '0px',
                          "padding-left":  (props.choosedOptions.badgeLeft !== "null" ||
                          props.choosedOptions.hasCustomBadgeLeft === "true") &&
                          props.choosedOptions.fullHeightBadge === "false" ? widthRearBadge + 8 + 'px' : '0px',
                        }}
                      >

                    <div style={{position: 'relative'}}>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateRear.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "CDE"
                              : props.choosedOptions.registrationNameSecond}
                          </span>
                        </div>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateRear.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "CDE"
                              : props.choosedOptions.registrationNameSecond}
                          </span>
                        </div>
                        <div
                          className="plate-preview__name"
                          style={{
                            "--font-size": sizePlateRear.fontField,
                            "line-height": "1",
                          }}
                        >
                          <span>
                            {props.defaultName
                              ? "CDE"
                              : props.choosedOptions.registrationNameSecond}
                          </span>
                        </div>
                      </div>
                       </div>
                      </>
                    )}
                  </div>
                )}
                {!sizePlateRear.breakLine && (
                  <div className="plate-preview__name-wr">
                    <div
                      className="plate-preview__name"
                      style={{ "--font-size": sizePlateRear.font }}
                    >
                      <span>
                        {props.defaultName
                          ? "AB12 CDE"
                          : props.choosedOptions.registrationName}
                      </span>
                    </div>
                    <div
                      className="plate-preview__name"
                      style={{ "--font-size": sizePlateRear.font }}
                    >
                      <span>
                        {props.defaultName
                          ? "AB12 CDE"
                          : props.choosedOptions.registrationName}
                      </span>
                    </div>
                    <div
                      className="plate-preview__name"
                      style={{ "--font-size": sizePlateRear.font }}
                    >
                      <span>
                        {props.defaultName
                          ? "AB12 CDE"
                          : props.choosedOptions.registrationName}
                      </span>
                    </div>
                  </div>
                )}
                {props.choosedOptions.showBSAU === "true" && (
                  <div
                    className={
                      props.choosedOptions.borderWidth === "null" ||
                      props.choosedOptions.borderWidth === "None"
                        ? "plate-preview__bsau bottom "
                        : "plate-preview__bsau"
                    }
                  >
                    SPM BSAU 145e
                  </div>
                )}
              </div>
              {((props.choosedOptions.badgeRight !== "null" &&
                !sizePlateRear.breakLine) ||
                (props.choosedOptions.badgeRight !== "null" &&
                  props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.hasCustomBadgeRight === "true" &&
                  !sizePlateRear.breakLine) ||
                (props.choosedOptions.hasCustomBadgeRight === "true" &&
                  props.choosedOptions.fullHeightBadge === "true") ||
                (props.choosedOptions.registrationNameSecond.length === 0 &&
                  !props.defaultName &&
                  (props.choosedOptions.badgeRight !== "null" ||
                    props.choosedOptions.hasCustomBadgeRight === "true"))) &&
                   (
                <div
                  className="plate-preview__badge plate-preview__badge--right"
                  style={{
                    "background-color":
                      props.choosedOptions.badgeColorRight !== "null" &&
                      props.choosedOptions.badgeColorRight,
                    color:
                      props.choosedOptions.customBadgeTextColorRight !==
                        "null" &&
                      props.choosedOptions.customBadgeTextColorRight,
                  }}
                >
                  {props.choosedOptions.hasCustomBadgeRight === "false" && (
                    <img
                      width="58"
                      height="132"
                      src={props.choosedOptions.badgeRight}
                      alt="badge"
                    />
                  )}
                  {props.choosedOptions.hasCustomBadgeRight === "true" &&
                    props.choosedOptions.customBadgeRight && (
                      <img
                        width="58"
                        height="132"
                        src={props.choosedOptions.customBadgeRight}
                        alt=" custom badge"
                      />
                    )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
